import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768; // Define your mobile breakpoint (e.g., 768px for tablets)

const useMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileView(mobile);
      if (!mobile) {
        setIsSidebarOpen(false); // Close sidebar when switching to desktop view
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return { isMobileView, isSidebarOpen, toggleSidebar };
};

export default useMobileView;